import React from 'react';
import View from '../../components/View';
import ViewHeader from '../../components/ViewHeader';
import ViewContent from '../../components/ViewContent';
import { withRouter } from 'react-router-dom';
import BulkDescriptionUploadContent from '../../components/BulkDescriptionUpload';

const BulkDescriptionUpload = () => {
  return (
    <View>
      <ViewHeader
        title="Bulk Description Upload"
        subtitle="Upload a csv file to bulk upload descriptions to properties"
      />
      <ViewContent>
        <BulkDescriptionUploadContent />
      </ViewContent>
    </View>
  );
};

export default withRouter(BulkDescriptionUpload);
